module.exports = __webpack_public_path__ + "static/img/banner-empleo-interno-500x750.f85a809.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-empleos/banner-empleo-interno-500x750.jpg
// module id = FJzG
// module chunks = 47